//PAQUETERIAS
import React, { useEffect, useState, useMemo, useRef } from "react";
import { CustomDialog } from "react-st-modal";
import NotificationSystem from "react-notification-system";
import dayjs from 'dayjs';

//COMPONENTES
import { date_current } from "../../../main_components/date/date";
import { previous_date } from "../../../main_components/date/date";

import { expenses_download } from "../../../services/expenses/expense";
import { base64toBlob } from "../../../main_components/donwloadfuncion/download";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";
import { BREADCRUMBS } from "../../../main_components/pagination/breadcrumbs";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
//ESTILOS
import "../../expense.css";
//IMAGENES/ICONOS
import SAVE from "../../../imgComponents/save.png";
import PDF from "../../../imgComponents/pdf.png";
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import SPECIAL_ACTIONS from "./tools/special_actions";
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../../main_components/methods_v2/export";
import EXPENSE_DETAIL from "../detail_expense/expense_datail_";
import { Box } from '@mui/material';
import { calculate_total } from "../../../main_components/methods_v2/auxiliary_functions";
import UPDATE_EXPENSE_V2 from "../tools/update_expense";
import SEARCH_FILTERS from "./tools/shearch_filter";


import { expenses_get } from "../../../services/expenses/expense";

const REPORT_EXPENSE_V2 = () => {
  const [ff, setff] = useState(dayjs(date_current));
  const [fi, setfi] = useState(dayjs(previous_date));
  const [sumCantidad, setSumCantidad] = useState(0);
  const [data, setData] = useState([]);
  const [rfc, setRFC] = useState(null);
  const [bp, setBP] = useState(null);
  const notificationSystemRef = useRef();
  const [modalT, setmodalT] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [total_rows, settotal_rows] = useState("");
  const [restriction_dt, setrestriction_dt] = useState("SC");
  const handleSubmit = async () => {
    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        if (totalG === 0) {
          try {
            setmodalT(true);
            var dt = await expenses_get(fi.format('YYYY-MM-DD'), ff.format('YYYY-MM-DD'), null, rfc, bp);
            setData(dt?.data?.sort((a, b) => (a.id < b.id ? 1 : a.id > b.id ? -1 : 0)));
            setmodalT(false);
          } catch (err) {
            console.log("error", err);
            setData([]);
            setmodalT(false);
          }
        } else {
          alert("Verifica que no tengas ningun gasto seleccionado");
        }
      } else {
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    handleSubmit();
  }, []);

  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input
            title="Seleccionar gasto"
            type="checkbox"
            ref={resolvedRef}
            {...rest}
          />
        </>
      );
    }
  );

  const [difT, setDifT] = useState([]);
  const [totalG, setTotalG] = useState(0);

  const result = difT?.filter((idExpense) => idExpense?.id != "elminarEsto");

  console.log(result);

  const handle_download = async (id, file_name) => {
    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        setmodalT(true);
        try {
          var dta = await expenses_download(id);
          const data = dta.data;
          var blob = base64toBlob(data.file);
          const blobUrl = URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          var arr = file_name.split("/");
          downloadLink.download = arr[4] + ".pdf";
          downloadLink.click();
          setmodalT(false);
        } catch (err) {
          setmodalT(true);
        }
      } else {
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const handleExpense = () => {
      setDifT(difT);
      setTotalG(totalG);
      setSumCantidad(sumCantidad);
    };
    handleExpense();
  }, []);


  const columns = useMemo(
    () => [
      {
        header: "Ac.",
        id: "ac",
        enableFilters: false,
        enableEditing: false,
        enableRowOrdering: false,
        enableGrouping: false,
        enableColumnDragging: false,
        enableColumnActions: false,
        enableFilterMatchHighlighting: false,
        enableColumnFilterModes: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 60,
        accessorFn: (d) => {
          return (
            <div>
              <img alt="" src={PDF} onClick={() => handle_download(d.id, d.file_name)} style={{ cursor: "pointer", margin: "2px" }} title="Descargar PDF"></img>
              <img alt="" src={SAVE} title="Editar Gasto"
                onClick={async () => {
                  if (d?.modifiable !== false) {
                    const result = await CustomDialog(
                      <UPDATE_EXPENSE_V2
                        codCocept={d?.concept}
                        codDescripcion={d?.description}
                        codDate={d?.date}
                        codImporte={d?.ammount}
                        codAccount={d?.account}
                        codIdPayment={d?.paiement_account}
                        id_expense={d?.id}
                        codidConcept={d?.id_account}
                        foreign={d?.origin === "EXTRANJERO" ? 1 : 0}
                        origin={d?.origin}
                        date_data={d?.payment_date}
                        concept={d?.concept}
                        handle_consult={handleSubmit}
                      ></UPDATE_EXPENSE_V2>,
                      {
                        className: "custom-modal",
                        title: "Editar Gasto",
                        showCloseIcon: true,
                        isCanClose: false,
                      }
                    );
                  } else {
                    alert("Este gasto ya no se puede modificar.");
                  }
                }
                }

              ></img>
            </div>
          );
        }
      },


      {
        id: "spend_folio_number",
        header: "No.",
        accessorKey: "spend_folio_number",
        size: 150,
        muiTableBodyCellProps: {
          align: 'center',
        },
      },

      {
        id: "order_number",
        header: "Orden de compra.",
        accessorKey: "order_number",
        size: 150,
        muiTableBodyCellProps: {
          align: 'center',
        },
      },

      {
        id: "date",
        header: "F. Recepción",
        accessorKey: "date",
      },
      {
        id: "date_document",
        header: "F. Documento",
        accessorKey: "date_document",
      },
      {
        id: "concept",
        header: "Concepto",
        accessorKey: "concept",
      },
      {
        id: "description",
        header: "Descripción",
        accessorKey: "description",
        size: 300,
        muiTableBodyCellProps: {
          align: 'left',
          whiteSpace: 'normal !important'
        },
      },
      {
        id: "ammount",
        header: "Importe",
        accessorKey: "ammount",
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: theme.palette.success.dark,
              borderRadius: '0.25rem',
              color: '#fff',
              maxWidth: '9ch',
              p: '0.25rem',
            })}
          >
            {cell.getValue()?.toLocaleString?.('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        ),
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
      },
      {
        id: "user_name",
        header: "Usuario",
        accessorKey: "user_name",
      },
      {
        id: "origin",
        header: "Origen",
        accessorKey: "origin",
      },
      {
        id: "modifiable",
        header: "Pagado",
        accessoKey: "modifiable",
        accessorFn: (d) => {
          return d.modifiable === false ? "✅" : "❌";
        },
      },
      {
        id: "payment",
        header: "Cuenta de pago",
        accessorKey: "payment",
      },
      {
        id: "scheduled_payment_date",
        header: "F. Vencimiento",
        accessorKey: "scheduled_payment_date",
      },
      {
        id: "payment_date",
        header: "F. Pago",
        accessorKey: "payment_date",
      },

      {
        id: "business_partner_name",
        header: "Proveedor",
        accessorKey: "business_partner_name"
      },
      {
        id: "rfc",
        header: "RFC Proveedor",
        accessorKey: "rfc"
      },

    ],
    []
  );

  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    settotal_rows(filteredRowsCount);
  };

  const update_identifiers =
    [
      { spend_folio_number: 'string' },
      { date: 'string' },
      { date_document: 'string' },
      { concept: 'string' },
      { description: 'string' },
      { ammount: 'string' },
      { user_name: 'string' },
      { origin: 'string' },
      { modifiable: 'string' },
      { payment: 'string' },
      { scheduled_payment_date: 'string' },
      { payment_date: 'string' },
      { business_partner_name: 'string' }
    ];


  return (
    <div >
      <NotificationSystem ref={notificationSystemRef}></NotificationSystem>
      <MODAL_TABLE open={true} modalT={modalT}></MODAL_TABLE>

      <BREADCRUMBS
        niveles={[
          { label: "REPORTE DE GASTOS", path: null },
          { label: "REPORTE DE GASTOS AGRUPADOS", path: "/expense_group" },
        ]}

        cards_dashboard={true}
        total_rows={total_rows !== "" ? total_rows : 0}
        filter_row={total_rows !== "" ? total_rows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={total_rows !== "" ? total_rows?.getPaginationRowModel()?.rows?.length : 0}
        total={data?.length}
      ></BREADCRUMBS>
      <div >

        <div className="new_table_v2">
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGrouping
            enableFacetedValues
            enableStickyHeader
            enableStickyFooter
            enableRowPinning
            enableColumnFilterModes
            enableRowSelection
            getRowId={(row) => row?.id}
            onRowSelectionChange={setRowSelection}
            enableTooltips={false}
            localization={MRT_Localization_ES}
            state={{ rowSelection, isLoading: isLoading }}
            enableColumnResizing
            enableColumnPinning
            enableColumnOrdering
            onStateChange={handleStateChange}
            enableExpandAll={false}
            enableColumnDragging={false}
            initialState={{ showGlobalFilter: true, showColumnFilters: true }}
            muiCircularProgressProps={{ color: 'secondary', thickness: 5, size: 55 }}
            muiSkeletonProps={{ animation: 'pulse', height: 28 }}
            rowVirtualizerInstanceRef
            rowVirtualizerOptions={{ overscan: 5 }}
            columnVirtualizerOptions={{ overscan: 2 }}
            muiTableContainerProps={{ sx: { maxHeight: '69vh', '@media (max-height: 810px)': { maxHeight: '65vh' } } }}
            positionToolbarAlertBanner="bottom"
            paginationDisplayMode='pages'
            rowPinningDisplayMode='sticky'
            layoutMode="grid"
            muiTableHeadCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
            muiTableBodyCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
            muiPaginationProps={{ color: 'primary', shape: 'rounded', variant: 'variant', }}
            displayColumnDefOptions={{
              'mrt-row-pin': {
                Header: () => (
                  <div>
                    <SPECIAL_ACTIONS setmodalT={setmodalT} setIsLoading={setIsLoading} rowSelection={rowSelection} total_rows={total_rows !== "" ? total_rows : []}></SPECIAL_ACTIONS>
                  </div>
                ),
                enableHiding: true,
              },
              'mrt-row-actions': {
                enableHiding: true,
              },
              'mrt-row-expand': {
                enableHiding: true,
              },
              'mrt-row-select': {
                enableHiding: true,
              }
            }}
            muiTableBodyRowDragHandleProps={({ table }) => ({
              onDragEnd: () => {
                const { draggingRow, hoveredRow } = table.getState();
                if (hoveredRow && draggingRow) {
                  data.splice(
                    hoveredRow.index,
                    0,
                    data.splice(draggingRow.index, 1)[0],
                  );
                  setData([...data]);
                }
              },
            })}
            muiTableBodyRowProps={
              ({ row, table }) => {
                settotal_rows(table);
                const { density } = table.getState();
                return {
                  sx: {
                    height: row.getIsPinned()
                      ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                      }px`
                      : undefined,
                  },
                };
              }
            }
            renderDetailPanel={({ row }) => {

              return (
                <EXPENSE_DETAIL
                  row={row}
                  setmodalT={setmodalT}
                  data={data}
                  columns={columns}
                  defaultPageSize={3}
                  showPagination={false}
                  verData={true}
                  foreign={null}
                />)
            }}

            renderTopToolbarCustomActions={({ }) => (
              <SEARCH_FILTERS
                setfi={setfi}
                fi={fi}
                setff={setff}
                ff={ff}
                setRFC={setRFC}
                rfc={rfc}
                setBP={setBP}
                bp={bp}
                restriction_dt={restriction_dt}
                total_rows={total_rows !== "" ? calculate_total((total_rows?.getSelectedRowModel()?.rows.map(d => d?.original?.ammount))) : 0}
                setrestriction_dt={setrestriction_dt}
                handle_get_sales={handleSubmit}
              ></SEARCH_FILTERS>
            )}


            renderToolbarInternalActions={({ table }) => (
              <RENDER_TOOLBAR_INTERNAL_ACTIONS
                table={table}
                file_name={"Polizas"}
                update_identifiers={update_identifiers}
                settotal_rows={settotal_rows}
              />
            )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default REPORT_EXPENSE_V2;
